declare function getPath(fieldPath: string, obj: any, mustExist?: boolean): null;
declare function cloneObject(obj: any): any;
export { getPath, cloneObject };
